/*
  CONFIGURATORE — supplementi nel carrello
  Il numero olografico e il montaggio sulle plastiche sono due prodotti a
  parte. Qui teniamo il conto, aggiorniamo il totale a schermo e li mettiamo
  nel carrello insieme alla grafica quando si preme il tasto.

  Importante: teniamo da parte la chiave (line item key) delle righe che
  abbiamo messo noi. Se il cliente toglie la spunta e riaggiunge la grafica,
  prima togliamo le vecchie righe dal carrello e poi rimettiamo solo quelle
  spuntate adesso. Cosi il prezzo non resta appiccicato.
*/
(function () {
  var controls = document.querySelector('.bc-controls');
  if (!controls) return;

  var VAR_MONT = controls.dataset.cfgMontaggioVariante || '';
  var CENT_MONT = parseInt(controls.dataset.cfgMontaggioCent, 10) || 0;
  var VAR_OLO = controls.dataset.cfgOloVariante || '';
  var CENT_OLO = parseInt(controls.dataset.cfgOloCent, 10) || 0;

  var boxMont = controls.querySelector('[data-cfg-mont-box]');
  var spunta = boxMont ? boxMont.querySelector('[data-cfg-montaggio]') : null;
  var apri = boxMont ? boxMont.querySelector('[data-cfg-box-plastiche]') : null;
  var radio = boxMont ? boxMont.querySelectorAll('[data-cfg-plastiche]') : [];
  var nota = boxMont ? boxMont.querySelector('[data-cfg-nota-plastiche]') : null;

  var olo = controls.querySelector('[data-cfg-olo]');
  var rigaOlo = controls.querySelector('[data-cfg-riga-olo]');
  var rigaMont = controls.querySelector('[data-cfg-riga-mont]');
  var totale = controls.querySelector('[data-cfg-totale]');
  var materiale = document.getElementById('bcMaterial');

  function euro(cent) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cent / 100);
    } catch (e) {
      return '€ ' + (cent / 100).toFixed(2).replace('.', ',');
    }
  }

  function scelta() {
    for (var i = 0; i < radio.length; i++) if (radio[i].checked) return radio[i].value;
    return '';
  }

  function aggiornaTotale() {
    if (!totale || !materiale) return;
    var pezzi = (materiale.value || '').split('|');
    var base = Math.round(parseFloat(pezzi[1] || '129') * 100);
    var somma = base;
    if (olo && olo.checked) somma += CENT_OLO;
    if (spunta && spunta.checked) somma += CENT_MONT;
    if (rigaOlo) rigaOlo.hidden = !(olo && olo.checked);
    if (rigaMont) rigaMont.hidden = !(spunta && spunta.checked);
    totale.textContent = euro(somma);
  }

  function aggiornaMontaggio() {
    if (!spunta) return;
    var attivo = spunta.checked;
    if (apri) apri.classList.toggle('visibile', attivo);
    for (var i = 0; i < radio.length; i++) radio[i].disabled = !attivo;
    if (nota) nota.hidden = !(attivo && scelta().indexOf('Nuove') === 0);
    aggiornaTotale();
  }

  if (spunta) spunta.addEventListener('change', aggiornaMontaggio);
  for (var k = 0; k < radio.length; k++) radio[k].addEventListener('change', aggiornaMontaggio);
  if (olo) olo.addEventListener('change', aggiornaTotale);
  if (materiale) materiale.addEventListener('change', function () { setTimeout(aggiornaTotale, 0); });

  aggiornaMontaggio();
  aggiornaTotale();

  var cta = document.getElementById('bcAddToCart');
  if (!cta) return;

  var CHIAVI = [];   // righe supplemento messe da questa pagina
  var inCorso = false;

  function togliVecchi() {
    if (!CHIAVI.length) return Promise.resolve();
    var lista = CHIAVI.slice();
    CHIAVI = [];
    var p = Promise.resolve();
    lista.forEach(function (chiave) {
      p = p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: chiave, quantity: 0 })
        });
      });
    });
    return p.catch(function () {});
  }

  function metti(extra) {
    if (!extra.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: extra })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.items) d.items.forEach(function (i) { if (i && i.key) CHIAVI.push(i.key); });
      })
      .catch(function () {});
  }

  cta.addEventListener('click', function () {
    if (cta.disabled || inCorso) return;

    var titolo = '';
    var attiva = document.querySelector('.bc-thumb.active');
    if (attiva) titolo = attiva.textContent.trim();
    titolo = titolo || 'Grafica dal configuratore';

    var extra = [];
    if (spunta && spunta.checked && VAR_MONT) {
      extra.push({ id: Number(VAR_MONT), quantity: 1,
        properties: { 'Per la grafica': titolo, 'Plastiche': scelta() } });
    }
    if (olo && olo.checked && VAR_OLO) {
      extra.push({ id: Number(VAR_OLO), quantity: 1,
        properties: { 'Per la grafica': titolo } });
    }

    if (!extra.length && !CHIAVI.length) return;

    inCorso = true;
    var fine = function () { inCorso = false; };
    togliVecchi().then(function () { return metti(extra); }).then(fine, fine);
  }, true);
})();
